import { Component, OnInit, ViewChild,AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from 'src/app/models/user';
import { ConfigService } from 'src/app/shared/services/config.service';
import { UserService } from 'src/app/modules/userModule/shared/user.service';
import { HttpService } from 'src/app/modules/assetModule/shared/services/http.service';
import { Asset } from 'src/app/models/asset';
import { LibraryBrowserComponent } from 'src/app/modules/assetModule/components/library-browser/library-browser.component';
import { AdministrationComponent } from 'src/app/modules/userModule/components/profile/administration-page/administration-page.component';
import { environment } from '../../../environments/environment';
import { ApplicationNamePipe } from '../../shared/pipe/application-name/user-group.pipe'
import { WizardService } from 'src/app/modules/userModule/shared/wizard.service';
import { FeaturesService } from 'src/app/shared/services/features-service/features.service';

@Component({
  selector: 'app-val-assets',
  templateUrl: './val-assets.component.html',
  styleUrls: ['./val-assets.component.css']
})
export class ValAssetsComponent implements OnInit,AfterViewInit {
  @ViewChild('administrationpage') administrationpage: AdministrationComponent;
  isSearch = false;
  library;
  userId = 5;
  loggedInUser: User = new User();
  name: string;
  prodConfig: any;
  filePrsent = true;
  feedbackComments = '';
  feedbackCommentsError = false;
  rating = 0;
  assetDetails = '';
  userStatistics: any;
  visibleManu = true;
  assetIdParms: string;
  asset: Asset = new Asset();
  searchKey = '';
  searchResults: any;
  filterKeys: any
  manageUserFlag = false;
  requestAccessFlag = false;
  folderid = '';
  folderName = 'Select Folder';
  userEmailId: string = '';
  folderIdParams: string;
  showAdministartion = false;
  userGroup: string = '';
  hasUploadAccess = false;
  previouseMenu: any;
  folderFlag = false;

  folderSerach = [];
  devUser: boolean = false;
  showAdministrationPage = false;
  featuresInVersion: any;
  userProfileImageURL: string = "assets/img/userDefault.png";
  isShowNotificationSuccess: boolean;
  showSuccessMessage: string;
  isShowNotificationError: boolean;
  showErrorMessage: string;
  theme_color : string;
  userinfo: User;
  constructor(private router: Router, public config: ConfigService,
    public userService: UserService, private httpService: HttpService,
    private wizardService: WizardService, private activatedRoute: ActivatedRoute, 
    private featuresService: FeaturesService) { }
  ngAfterViewInit(): void {
    if(sessionStorage.getItem("isloaded")==null && this.theme_color==='light'){
      sessionStorage.setItem("isloaded","true");
      window.location.reload();
    }
  }

  ngOnInit() {
    this.theme_color = this.userService.loggendInUser.userSettings.userThemeType===0?'dark':'light';
    if(sessionStorage.getItem('authentication')==null){
      sessionStorage.clear();
      this.router.navigateByUrl('login');
    }

    
    this.httpService.folderCategory.subscribe(fol => this.folderFlag = fol.isFolder);
    
    if (!sessionStorage.getItem('userinfo')) {
      this.userService.loginUser().subscribe(
        data => {
          let response: any = data;
          this.userService.loggendInUser = response.userDetails as User;
          this.name = this.userService.loggendInUser.name;
          sessionStorage.setItem('userinfo', JSON.stringify(this.userService.loggendInUser));
        },
        error => {
          console.log(error);
        }
      );
    }
    this.config.getConfig().subscribe(
      data => {
        this.prodConfig = data;
      }, err => {
        this.filePrsent = false;
      }
    );
    if (this.loggedInUser.name == '') {
      this.loggedInUser = JSON.parse(sessionStorage.getItem('userinfo')) as User;
      this.name = this.loggedInUser ? this.loggedInUser.name : '';
      this.userEmailId = this.loggedInUser.userEmailId;
      console.log(this.name);
    }
    let url = this.router.url;
    console.log(url);
    // alert('cakls')
    this.config.searchActive = false;
    this.config.homeActive = false;
    this.config.personalBrowserActive = false;
    const userGroupPipe = new ApplicationNamePipe();
    this.loggedInUser.userGroup = userGroupPipe.transform(this.userService.loggendInUser.applicationName, "VAL Web App");
    if (this.loggedInUser.userGroup === 'Admin' || this.loggedInUser.userGroup === 'L1') {
      this.hasUploadAccess = true;
    }
    if (url.indexOf('search') > 0) {
      this.config.searchActive = true;
    } else if (url.indexOf('home') > 0) {
      this.config.homeActive = true;
    } else if (url.indexOf('personal-browser') > 0) {
      this.config.personalBrowserActive = true;
    } else if (url.indexOf('upload-new-asset') > 0) {
      this.config.uploadAssetsActive = true;
    }

    if (this.loggedInUser.userGroup == 'Admin') {
      this.manageUserFlag = true;
    }
    this.httpService.getBasePath().then(e => {
      this.getRootFolder();
      this.fetchUserProfileImage(this.userEmailId);
    });
    this.httpService.currentsearchResults.subscribe(searchResults => {
      this.searchResults = searchResults.search;
      this.searchKey = searchResults.searchKey;
      this.folderid = searchResults.folderid;
      if (this.folderid === '' || this.folderid == null) {
        this.folderName = 'Select Folder';
      }
    });
    this.loggedInUser.applicationName.forEach((app) => {
      if (app.userGroup == "SuperUser")
        this.requestAccessFlag = true;
      if (app.userGroup == "Developer")
        this.devUser = true;
    });
    this.wizardService.createWizard(this.loggedInUser);
  }

  paddright(ev) {
    let left = document.getElementById(ev).style.left;
    var elem = document.getElementById(ev);
    var style = elem.getAttribute("style");
    style = style.replace(left, (parseInt(left) + 20 + "px !important"))
    elem.setAttribute("style", style);
  }
  changeActive(ev) {
    var elem = ev.target;
    if (this.previouseMenu != undefined && this.previouseMenu != elem)
      this.previouseMenu.removeAttribute("active");
    elem.setAttribute("active", "true");
    this.previouseMenu = elem;
  }

  search() {
    this.isSearch = true;
    this.folderFlag = !this.folderFlag;
    this.httpService.changeFolderFlag(this.folderFlag);
    this.router.navigateByUrl('/val-assets/search');
  }
  getAssetCategory() {
    if (this.isSearch) {
      this.folderFlag = !this.folderFlag;
      this.httpService.changeFolderFlag(this.folderFlag);
    }
  }
  showFolderCategory() {
    this.httpService.changeFolderFlag(false);
  }
  personalBrowser() {
    this.isSearch = false;
    this.folderFlag = false;
    this.httpService.changeFolderFlag(this.folderFlag);
    this.router.navigateByUrl('/val-assets/personal-browser');
  }
  
  logout() {
    sessionStorage.clear();
    window.open(environment.logoutUrl, '_self');
  }

  openFeedbackModal() {

    this.feedbackComments = '';
    this.feedbackCommentsError = false;
    this.rating = 0;
    //To check if any asset is being previewed then show the asset name in the feedback modal
    if ((window.location.href.includes('/assets/') === true || window.location.href.includes('upload-assets') === true) && this.httpService.assetDetails) {
      this.assetDetails = ' for ' + this.httpService.assetDetails.assetName + ' version ' + this.httpService.selectedVersionNumber;
    }
    else {
      this.assetDetails = '';
    }

    document.getElementById('feedbackModal').setAttribute('visible', 'true')
  }

  submitFeedback() {
    if (this.rating != 0 || this.feedbackComments.trim() !== '') {
      let feedback = {
        feedbackComments: this.feedbackComments,
        rating: this.rating,
        userEmailId: this.loggedInUser.userEmailId,
        userName: this.loggedInUser.name,
        assetId: this.httpService.assetDetails ? this.httpService.assetDetails.assetId : null,
        assetName: this.httpService.assetDetails ? this.httpService.assetDetails.assetName : null,
        assetVersion: this.httpService.selectedVersionNumber
      };
      this.userService.submitFeedback(feedback).subscribe(
        () => {
          this.assetDetails = '';
          document.getElementById('feedbackModal').removeAttribute('visible');
        }
      );
    }
  }

  feedbackModalClick(event) {
    if (event.target.id == 'feedbackModal') {
      event.stopPropagation();
    }
  }

  // showActiveUsersModal() {
  //   this.userService.getUserStatistics().subscribe(
  //     data => {
  //       this.userStatistics = data;
  //       if (this.userStatistics) {
  //         document.getElementById('activeUsersModal').setAttribute('visible', 'true')
  //       }
  //     }
  //   );
  // }

  emailStatistics() {
    this.userService.getUserStatistics(this.loggedInUser.userEmailId).subscribe(
      () => {
        // alert('Email has been sent.');
        this.successNotification("Email has been sent.");
      }
    );
  }
  getRootFolder() {
    this.httpService.getRootFolderData(this.loggedInUser.userEmailId).subscribe(
      data => {
        this.library = data;
        this.httpService.folder = this.library[0].subFolders[0];
        this.folderSerach = this.library[0].subFolders;
        this.activatedRoute.params.subscribe(
          params => {
            this.assetIdParms = params.assetId;
            this.folderIdParams = params.folder;
            if (this.assetIdParms || this.folderIdParams) {
              this.httpService.autoLoadTree = true;

            }
          }, err => console.log(err)
        );
      },
      error => {
        console.log(error);
      }
    );
  }
  administration() {
    this.showAdministartion = true;
    document.querySelector('activeUsersModal').setAttribute('visible', 'true')

  }
  assetRelativePathRecive(path) {
    console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>', path);
    this.asset.relativePath = path + `,${this.asset.name}`;
  }

  reset() {
    this.httpService.getRootFolderData(this.loggedInUser.userEmailId).subscribe(
      data => {
        this.library = data;
      },
      error => { }
    );
  }
  clear(event) {

    this.httpService.changesearchResults(null, null, null, null);
  }

  searchAssets(event: KeyboardEvent) {
    this.searchResults = null;
    this.searchKey = event.target['value'];
    if (event.keyCode === 13) {
      if ((this.searchKey === undefined || this.searchKey === null) && !this.folderid) {
        this.reset();
        return;
      } else if ((this.searchKey === undefined || this.searchKey === null || this.searchKey === '') && this.folderid) {
        this.searchKey = ' ';
      }
      if (this.folderid === null) {
        this.folderid = '';
      }
      this.httpService.searchAssets(this.searchKey, this.userService.loggendInUser.userEmailId, this.folderid).subscribe(
        (data: any) => {
          this.searchResults = data.searchResults;
          this.filterKeys = data.filterByValues;
          // this.library = this.searchResults.folders;
          event.target['value'] = this.searchKey;
          this.httpService.changesearchResults(this.searchResults, this.folderid, this.searchKey, this.filterKeys);
          this.router.navigateByUrl('/val-assets/search');

        },
        error => {
          // alert('No Assets Found');
          this.errorNotification("No Assets Found");
          this.searchKey = '';
          this.folderName = 'Search Folder';
          this.folderid = '';
          this.httpService.changesearchResults(null, '', '', null);
          this.router.navigateByUrl('/val-assets/search');
          console.log(error);
        }
      );
    }
  }

  searchFolderLibrary(fold: any) {
    this.httpService.getLibraryFolderStructure(fold._id, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        fold.subFolders = data.subFolders;

      }, err => {
        console.error(err);
      }
    );
    this.folderid = fold._id ? fold._id : '';
    this.folderName = fold.name;
  }
  searchSubFolderLibrary(fol: any) {
    this.httpService.getLibraryFolderStructure(fol._id, this.userService.loggendInUser.userEmailId).subscribe(
      data => {
        fol.subFolders = data.subFolders;
        if (fol.subFolders) {
          fol.subFolders.forEach(folder => {
            this.httpService.getLibraryFolderStructure(folder._id, this.userService.loggendInUser.userEmailId).subscribe(
              data => {
                folder.subFolders = data.subFolders;
              }, err => {
                console.error(err);
              });
          });
        }
      }, err => {
        console.error(err);
      }
    );
    this.folderid = fol._id ? fol._id : '';
    this.folderName = fol.name;
  }
  resetFolder() {
    this.folderid = '';
    this.folderName = 'Select Folder';
  }

  assignFolderValue(folder) {
    this.folderid = folder._id ? folder._id : '';
    this.folderName = folder.name;
  }
  downloadHelp() {
    window.open('/assets/HelpFile.pdf', '_blank');
  }

  showAdministrationPageModal() {
    this.showAdministrationPage = true;
  }

  closeAdministrationPageModal() {
    this.showAdministrationPage = false;
  }

  showTermsAndConditions() {
    document.getElementById('termsModalView').setAttribute('visible', 'true');
  }

  openProductInformationModal() {
    document.getElementById('configModal').setAttribute('visible', 'true');
    this.getFeaturesInVersion();
  }

  getFeaturesInVersion() {
    this.featuresService.getFeaturesInVersion().subscribe(
      (data: any) => {
        this.featuresInVersion = data.FeaturesInVersion;
      }
    );
  }

  fetchUserProfileImage(userEmailId: string) {
    this.userService.fetchUserProfileImage(userEmailId).subscribe((userImage) => {
      if(userImage != null){
        this.userProfileImageURL = 'data:image/png;base64,' + userImage;
      }
      else {
        this.userProfileImageURL = 'assets/img/userDefault.png';
      }
      
    },
    (err) => {
      console.log(err);
    });
  }

  updateThemeSetting(){
    this.userinfo = JSON.parse(sessionStorage.getItem('userinfo'));
    let previousThemeColor = this.userinfo.userSettings.userThemeType;
    this.userinfo.userSettings.userThemeType = previousThemeColor===0?1:0;
    if(this.userinfo.userSettings.userThemeType==0){
      document.documentElement.setAttribute('theme','dark');
      this.httpService.changeThemeFlag('dark');
    }else{
      document.documentElement.setAttribute('theme','light');
      this.httpService.changeThemeFlag('light');
    }
    this.userService.updateUserSettings(this.userinfo).subscribe(
      data => {
        this.userService.loggendInUser = data;
        sessionStorage.setItem('userinfo', JSON.stringify(data));
        sessionStorage.setItem("isloaded","true");
      },
      err=>{
        this.errorNotification('Error Occured');
      }
      );
    
  }
  successNotification(message){
    this.isShowNotificationSuccess = true;
    this.showSuccessMessage = message;
    setInterval(()=>{
      this.isShowNotificationSuccess = false;
    },5000)
  }

  errorNotification(message){
    this.isShowNotificationError = true;
    this.showErrorMessage = message;
    setInterval(()=>{
      this.isShowNotificationError = false;
    },5000)
  }

  isHomeComponent(){
    return this.router.url.indexOf('home') > 0;
  }
}
